import { PageEvent } from '@angular/material/paginator';
import { createAction, props } from '@ngrx/store';
import {
  AutoPairGlobalConfiguration,
  AutoPairTransitProgramConfiguration,
  OperationalFootprintConfiguration,
  TransitProgramInfo
} from '@uzurv/clara';
import { HttpException } from '@uzurv/core';
import { OperationalFootprintInfo } from 'projects/sdk/packages/clara/src/models/operational-footprint';
import { AutopairingState } from './autopairing.reducer';

// Global configuration actions for autopairing

export const GetAutopairingGlobalConfig = createAction('[AutoParing] Get global config');

export const GetAutopairingGlobalConfigSuccess = createAction(
  '[AutoPairing] Get global config success',
  props<{ config: AutoPairGlobalConfiguration }>()
);
export const GetAutopairingGlobalConfigFail = createAction('[AutoPairing] Get global config fail', props<{ error: any }>());

// Save global configuration actions for autopairing

export const SaveAutopairingGlobalConfig = createAction(
  '[AutoPairing] Save global config',
  props<{ config: AutoPairGlobalConfiguration }>()
);

export const SaveAutopairingGlobalConfigSuccess = createAction(
  '[AutoPairing] Save global config success',
  props<{ config: AutoPairGlobalConfiguration }>()
);

export const SaveAutopairingGlobalConfigFail = createAction('[AutoPairing] Save global config fail', props<{ error: any }>());

// Global Configuration actions for tab state management

export const StoreAutopairingGlobalFormValues = createAction(
  '[AutoPairing] Store global form values',
  props<{ formValues: AutoPairGlobalConfiguration }>()
);

// Handle state from Tab actions

export const RestoreState = createAction('[AutoPairing] Restore state from tab', props<{ state: AutopairingState }>());

export const ClearState = createAction('[AutoPairing] Clear state');

// Manage home page tab index

export const SetAutopairingTabIndex = createAction('[AutoPairing] Set tab index', props<{ index: number }>());

// Operational Footprint Actions

export const GetOperationalFootprints = createAction('[AutoPairing] Get operational footprints');

export const GetOperationalFootprintsSuccess = createAction(
  '[AutoPairing] Get operational footprints success',
  props<{ operationalFootprints: Array<OperationalFootprintInfo> }>()
);

export const GetOperationalFootprintsFail = createAction(
  '[AutoPairing] Get operational footprints fail',
  props<{ error: HttpException }>()
);

export const GetOperationalFootprintConfig = createAction(
  '[AutoPairing] Get operational footprint config',
  props<{ operationalFootprintId: number }>()
);

export const GetOperationalFootprintConfigSuccess = createAction(
  '[AutoPairing] Get operational footprint config success',
  props<{ config: OperationalFootprintConfiguration }>()
);

export const GetOperationalFootprintConfigFail = createAction(
  '[AutoPairing] Get operational footprint config fail',
  props<{ error: any }>()
);

export const SelectOperationalFootprint = createAction(
  '[AutoPairing] Select operational footprint',
  props<{ selectedOperationalFootprint: OperationalFootprintInfo }>()
);

export const ClearSelectedOperationalFootprint = createAction('[AutoPairing] Clear selected operational footprint');

export const SaveAutopairingOperationalFootprintConfig = createAction(
  '[Autopairing] Save autopairing operational footprint config',
  props<{ operationalFootprintId: number; config: OperationalFootprintConfiguration }>()
);

export const SaveAutopairingOperationalFootprintConfigSuccess = createAction(
  '[AutoPairing] Save autopairing operational footprint config success',
  props<{ config: OperationalFootprintConfiguration }>()
);

export const SaveAutopairingOperationalFootprintConfigFail = createAction(
  '[Autopairing] Save autopairing operational footprint config fail',
  props<{ error: HttpException }>()
);

export const StoreAutopairingOperationalFootprintFormValues = createAction(
  '[Autopairing] Store autopairing operational footprint form values',
  props<{ formValues: OperationalFootprintConfiguration }>()
);

export const ClearAutopairingOperationalFootprintFormValues = createAction(
  '[AutoPairing] Clear autopairing operational footprint form values'
);

// Transit Program Search Actions

export const GetTransitPrograms = createAction('[AutoPairing] Get transit programs');

export const GetTransitProgramsSuccess = createAction(
  '[AutoPairing] Get transit programs success',
  props<{ transitPrograms: Array<TransitProgramInfo> }>()
);

export const GetTransitProgramsFail = createAction('[AutoPairing] Get transit programs fail', props<{ error: HttpException }>());

export const SearchTransitPrograms = createAction('[AutoPairing] Search transit programs', props<{ searchString: string }>());

export const SearchTransitProgramsSuccess = createAction(
  '[AutoPairing] Search transit programs success',
  props<{ transitPrograms: Array<TransitProgramInfo> }>()
);

export const SearchTransitProgramsFail = createAction('[AutoPairing] Search transit programs fail', props<{ error: HttpException }>());

export const ClearSearch = createAction('[AutoPairing] Clear search');

export const PaginateTransitPrograms = createAction('[AutoPairing] Paginate transit programs', props<{ pageEvent: PageEvent }>());

export const SelectTransitProgram = createAction(
  '[AutoPairing] Select transit program',
  props<{ selectedTransitProgram: TransitProgramInfo }>()
);

export const ClearSelectedTransitProgram = createAction('[AutoPairing] Clear selected transit program');

// Get Transit Program Configuration

export const GetAutopairingTransitProgramConfig = createAction(
  '[AutoParing] Get autopairing transit program config',
  props<{ transitProgramId: number }>()
);

export const GetAutopairingTransitProgramConfigSuccess = createAction(
  '[AutoPairing] Get autopairing transit program config success',
  props<{ config: AutoPairTransitProgramConfiguration }>()
);

export const GetAutopairingTransitProgramConfigFail = createAction(
  '[AutoPairing] Get autopairing transit program config fail',
  props<{ error: HttpException }>()
);

export const SaveAutopairingTransitProgramConfig = createAction(
  '[AutoPairing] Save autopairing transit program config',
  props<{ transitProgramId: number; config: AutoPairTransitProgramConfiguration }>()
);

export const SaveAutopairingTransitProgramConfigSuccess = createAction(
  '[AutoPairing] Save autopairing transit program config success',
  props<{ config: AutoPairTransitProgramConfiguration }>()
);

export const SaveAutopairingTransitProgramConfigFail = createAction(
  '[AutoPairing] Save autopairing transit program config fail',
  props<{ error: HttpException }>()
);

export const StoreAutopairingTransitProgramFormValues = createAction(
  '[AutoPairing] Store autopairing transit program form values',
  props<{ formValues: AutoPairTransitProgramConfiguration }>()
);

export const ClearAutopairingTransitProgramFormValues = createAction('[AutoPairing] Clear autopairing transit program form values');
